import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const MinusCircleFillLarge = (props: SvgIconT.Props) => (
  <SvgIcon width={24} {...props} viewBox="0 0 24 24">
    <path d="M11.5 2.714c-5.225 0-9.5 4.275-9.5 9.5s4.275 9.5 9.5 9.5 9.5-4.275 9.5-9.5-4.275-9.5-9.5-9.5zm5.5 10H6v-1h11v1z"></path>
  </SvgIcon>
);

export default MinusCircleFillLarge;
